import React from 'react';
import { Spinner } from 'reactstrap';
import LoadingOverlay, { LoadingOverLayProps } from 'react-loading-overlay-ts';

const PayerLoadingOverlay = ({ ...props }: LoadingOverLayProps) => (
  <LoadingOverlay fadeSpeed={300} {...props} spinner={<Spinner />} text={undefined} />
);

export { PayerLoadingOverlay };
